import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import Select from 'react-select';
import { IOption } from '../../types/options';
import selectStyles from './styles';
import styles from './filter-searchparam.module.scss';

type FilterSearchParamProps = {
  label: string,
  name: string,
  options: IOption[],
  feminine?: boolean,
};

const FilterSearchParam = (
  {
    label,
    name,
    options,
    feminine = false,
  } : FilterSearchParamProps,
) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSetUrlSearchParam = (opt: IOption | null) => {
    const params = new URLSearchParams(searchParams);
    params.delete('skip');
    params.delete('page');
    if (opt && opt.value !== 'all') params.set(name, opt.value as string);
    else if (!opt || opt?.value === 'all') params.delete(name);
    setSearchParams(params);
  };

  const searchValue = searchParams.get(name);

  const optionAll = { label: feminine ? 'Toutes' : 'Tous', value: 'all' };
  const allOptions = [
    optionAll,
    ...options,
  ];

  const value = useMemo(
    () => (searchValue
      ? (allOptions.find((opt) => opt.value === searchValue) || optionAll)
      : optionAll),
    [options, searchParams],
  );

  return (
    <div className={styles.container}>
      <label>{label}&nbsp;:</label>
      <Select
        value={value}
        options={allOptions}
        styles={selectStyles}
        onChange={(opt) => {
          handleSetUrlSearchParam(opt);
        }}
        defaultValue={null}
        isSearchable={true}
      />
    </div>
  );
};

export default FilterSearchParam;
